import styled from 'styled-components';

export const Section3 = () => {
  return (
    <Container>
      <Title>{'절차 안내'}</Title>

      <Procedure
        text={'내 트랙터를 판매하기 위한 정보들을 준비하시고, 하단에 “시작하기” 버튼을 통해 판매 신청을 해주세요.'}
      />
      <Procedure text={'플루바 마켓의 담당자가 신청 매물을 확인하고 승인 절차를 거칩니다.'} />
      <Procedure text={'매물 확인 후 보통 하루안에 “직거래 매물”로 판매가 시작됩니다. (최장 3일 소요)'} />
      <Procedure text={'판매 시작후, 매물의 구입을 원하는 분들께서 등록된 연락처로 전화 문의를 드립니다.'} />
      <Procedure text={'트랙터 인도 및 명의 이전, 대금 처리를 완료 해주시면 “내 트랙터 판매”하기 완료!'} />
    </Container>
  );
};

interface ProcedureProps {
  text: string;
}

const Procedure = ({ text }: ProcedureProps) => {
  return (
    <ProcedureWrap>
      <DotWrap>
        <Dot />
      </DotWrap>
      <ProcedureText>{text}</ProcedureText>
    </ProcedureWrap>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  padding: 32px var(--radius-large, 16px);
  gap: var(--radius-large, 16px);

  background-color: white;
`;

const Title = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const DotWrap = styled.div`
  width: 20px;
  height: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const Dot = styled.div`
  width: var(--radius-small, 4px);
  height: var(--radius-small, 4px);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 10px;
  flex-shrink: 0;

  border-radius: var(--radius-round, 80px);
  background: var(--Light-Scheme-Monochrome-grey100, #858894);
`;

const ProcedureText = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* Display/Large/l-light */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 130%; /* 20.8px */
`;

const ProcedureWrap = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  align-self: stretch;

  gap: var(--radius-small, 4px);
`;
